import { useContext } from 'react';
import { Form } from 'react-bootstrap';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { FixingContext, useValidateFixing } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectFixingReference, selectFixingTypes } from '@/store/orders/fixing/selectors.ts';

export const FixingReference = () => {
  const tileId = useContext(FixingContext).tileId;
  const fixingReference = useAppSelector((state) => selectFixingReference(state, tileId));
  const fixingsTypes = useAppSelector((state) => selectFixingTypes(state, tileId));
  const track = useTrackEvent();

  const validateFixing = useValidateFixing();

  const handleChangeReference = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Fixing reference changed');
    const newReference = event.target.value;

    validateFixing({
      fixingReference: newReference,
    });
  };

  return (
    <OrderRow labelId="order.fields.fixingReference">
      <Form.Select
        value={fixingReference}
        onChange={handleChangeReference}
        size="sm"
        data-e2e="fixing-reference-selector"
      >
        {fixingsTypes?.map((fixingTypes) => (
          <option key={fixingTypes} value={fixingTypes}>
            {fixingTypes}
          </option>
        ))}
      </Form.Select>
    </OrderRow>
  );
};
